import styled from "styled-components";

interface ImageProps {
    bg: any;
    height: string;
}

export const ImageBox = styled.div<ImageProps>`
    background-image: ${(props) => props.bg};
    min-height: ${(props) => props.height};
    width: 100%;
    background-size: cover;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;

`;